import { toValue } from 'vue'
import { defineStore } from 'pinia'
import Template from '@/classes/templates/Template'

export const useTemplateStore = defineStore('TemplateStore', {
  state: () => ({
    template: {},
    loader: false,
    error: {}
  }),
  getters: {
    getTemplate: state => ({ id }) => state.$getItem({
      resource: 'template',
      key: id,
      fetch: () => state.fetchTemplate({ id })
    })
  },
  actions: {
    async fetchTemplate ({ id }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$fetchItem({
        endpoint: `/api/v1/templates/${toValue(id)}`,
        resource: `template.${toValue(id)}`,
        model: Template
      })
    }
  }
})